import PenawaranApi from './PenawaranApi'

export default PenawaranApi